import { injectOptional } from '@/tsyringe-extend'
import deepmerge from 'deepmerge'
import { defineStore } from 'pinia'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import type { Router } from 'vue-router'
import { CORE_PLUGIN, CORE_ROUTER } from '../../../../core'
import type { Plugin } from '../../../Plugin'
import { PLUGIN_PORTAL_PAGE } from '../../BuiltinPluginSymbol'
import PortalPageLayout from './views/PageLayout.vue'
import { type PortalPageOption, PortalPageOptionInjectKey } from './Normal'
export * from './Normal'
/**
 * 插件的Option定义
 */
export const PORTAL_ROUTE_NAME = 'normal'
export const createDefaultPortalPageOption = () => {
  return {
    path: '/normal',
    name: 'normal',
    layout: {
      normal: {
        head: {
          left: [],
          right: [],
          center: [],
        },
        footer: {
          center: [],
        },
      },
    },
  } as PortalPageOption
}
/**
 * Pinia Getter Type
 */
// eslint-disable-next-line @typescript-eslint/ban-types
type PortalPageGetter = {}
/**
 * Pinia Action Type
 */
// eslint-disable-next-line @typescript-eslint/ban-types
type PortalPageAction = {}
/**
 * 将Getter/Action合并为类型
 */
export type PortalPageService = PortalPageGetter & PortalPageAction

export const useNormalPageLayout = defineStore(PLUGIN_PORTAL_PAGE.toString(), {
  state: () => createDefaultPortalPageOption(),
  getters: {},
  actions: {},
})

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<
      Plugin<PortalPageOption, PortalPageService>
    >((c) => c.resolve(DefaultPortalPagePlugin)),
  },
  {
    token: PLUGIN_PORTAL_PAGE,
    useFactory: instanceCachingFactory<
      Plugin<PortalPageOption, PortalPageService>
    >((c) => c.resolve(DefaultPortalPagePlugin)),
  },
])
@injectable()
export class DefaultPortalPagePlugin
  implements Plugin<PortalPageOption, PortalPageService>
{
  id: string | symbol = PLUGIN_PORTAL_PAGE
  options: PortalPageOption
  service: PortalPageService

  constructor(
    @injectOptional(PortalPageOptionInjectKey)
    options?: Partial<PortalPageOption>
  ) {
    this.options = createDefaultPortalPageOption()
    if (options) {
      this.options = deepmerge(this.options, options)
    }
    const store = useNormalPageLayout()
    store.$patch(this.options)
    this.service = store
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const router = container.resolve<Router>(CORE_ROUTER)
    router.addRoute({
      path: this.options.path,
      name: this.options.name,
      component: PortalPageLayout,
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {
    // throw new Error("Method not implemented.")
  }
}
